import { connect } from '@atlassian/jira-react-redux';
import mapDispatchToProps from './command';
import mapStateToProps from './query';
import Select, { SelectForColumnCell as ColumnCellSelect } from './view';
import ColumnCellSelectWithRollup from './with-roll-up';

// eslint-disable-next-line jira/export/no-external-exports
export { selectUtils } from '@atlassian/jira-portfolio-3-common';

export default Select;
export { AsyncSelect, MIN_SELECT_WIDTH } from './view';

export const SelectForColumnCell = connect(null, mapDispatchToProps)(ColumnCellSelect);

export const CellSelectWithRollup = connect(
	mapStateToProps,
	mapDispatchToProps,
)(ColumnCellSelectWithRollup);
